import styled from "styled-components";

import Nav from "/component/layout/Nav";
import { layout, transition } from "/styles";

export const NavMenu = styled(Nav)(transition.fadeDown, layout.absoluteFill);
